import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * 终端类型
 */
export const useTerminalTypeStore = create()(
  devtools(
    set => {
      return {
        isMobile: false,
        /**
         * 设置用户信息
         */
        setIsMobile: bool => set({ isMobile: bool }),
      };
    },
    { name: 'useTerminalTypeStore' }
  )
);
